module.exports = __webpack_public_path__ + "static/media/usecasesection2.425913a3.png";